// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CA_CLOSE_COST_MODEL,
} from './constants';

export function closeCostModel() {
  return {
    type: CA_CLOSE_COST_MODEL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_CLOSE_COST_MODEL:
      return {
        ...state,
        caSelected:null,
        project:-1,
        openCostModelDialog:false
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/closeCostModel.js